<template>
    <v-card component="CharacterBlacklist" :class="[{ isOpen }, { 'small-design': $vuetify.breakpoint.sm }]">
        <draggable
            v-if="!isOpen"
            v-bind="dragOptions"
            group="people"
            :list="project.blacklist"
            @start="checkMove"
            @add="onAdd"
            :filter="'.disabled'"
            :component-data="{ attrs: { character: null } }"
            :disabled="projectWasClosed"
        >
            <v-card-title class="title">
                <button size="iconSmall" color="ghost" @click="isOpen = !isOpen">
                    <i v-if="isOpen" class="icon">remove</i>
                    <i v-else class="icon">add</i>
                </button>
                Blacklist
                <div class="count">{{ getCount }}</div>
            </v-card-title>
        </draggable>

        <v-card-title class="title" v-else>
            <button size="iconSmall" color="ghost" @click="isOpen = !isOpen">
                <i v-if="isOpen" class="icon">remove</i>
                <i v-else class="icon">add</i>
            </button>
            Blacklist
            <div class="count">{{ getCount }}</div>
        </v-card-title>

        <v-list v-if="isOpen">
            <draggable
                v-bind="dragOptions"
                group="people"
                :list="project.blacklist"
                @start="checkMove"
                @add="onAdd"
                :filter="'.disabled'"
                :component-data="{ attrs: { character: null } }"
                :disabled="projectWasClosed"
            >
                <character-blacklist-item
                    class="disabled"
                    :actor="actor"
                    v-for="actor in project.blacklist"
                    :key="`blacklist-${actor.id}`"
                    @removeActor="onRemove"
                />
            </draggable>
        </v-list>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import CharacterBlacklistItem from './CharacterBlacklistItem';

export default {
    name: 'CharacterBlacklist',

    data() {
        return {
            isOpen: true,
            dragOptions: {
                ghostClass: 'ghost',
            },
        };
    },

    async created() {},

    async mounted() {},

    methods: {
        ...mapActions(['projectRemoveActorFromBlacklist', 'projectAddActorToBlacklist']),

        onAdd(evt) {
            this.projectAddActorToBlacklist({
                actorId: parseInt(evt.item.getAttribute('voice')),
                projectId: this.project.id,
            });
        },

        onRemove(actorId) {
            this.projectRemoveActorFromBlacklist({
                actorId: actorId,
                projectId: this.project.id,
            });
        },

        checkMove(evt) {
            // odrb na blikanie ghostu v cieli dropovania
            evt.item.style.display = 'flex';
        },
    },

    computed: {
        ...mapGetters({
            project: 'getProject',
            projectWasClosed: 'projectWasClosed',
        }),

        getCount() {
            const count = this.project.blacklist.length;
            return count > 1 ? count + ' voices' : count + ' voice';
        },
    },

    components: {
        draggable,
        CharacterBlacklistItem,
        Mp3Player,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

.ghost {
    opacity: 0.5;
    background-color: white;
    border: none;
    display: none;
}

[component='CharacterBlacklist'] {
    display: flex;
    flex-direction: column;
    height: 45px;
    transition: 0.5s;
    overflow: hidden;

    &.isOpen {
        height: 22%;
    }

    .title {
        padding: 6px 15px 6px 8px !important;
        color: black;
        height: 45px;

        button {
            margin-right: 5px;
        }

        .count {
            margin-left: auto;
            font-size: 14px;
        }
    }

    &.small-design {
        height: auto;
        margin: 0 0 10px 0;
    }

    .v-list {
        height: 0;
        overflow-y: auto;
        flex-grow: 1;
        flex-basis: 0;
        overflow-x: hidden;
        padding: 0;
    }
}
</style>
